module.exports = fox._r("images/bg/subscribe_block_bg.jpg", __webpack_public_path__ + "images/bg/subscribe_block_bg.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/bg/subscribe_block_bg.jpg
// module id = 161
// module chunks = 5